import { qs } from '../lib/dom.js';

export function initContactPage() {
  // Lazy-load the Google Maps iframe once it scrolls into view - the embed
  // is heavy and the map section sits below the fold.
  const iframe = qs('.ap-info-map iframe[data-src]');
  if (iframe) {
    if (typeof IntersectionObserver !== 'undefined') {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            iframe.src = iframe.dataset.src;
            iframe.removeAttribute('data-src');
            io.disconnect();
          }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(iframe);
    } else {
      iframe.src = iframe.dataset.src;
    }
  }

  // The contact form itself is handled by components/contact-form.js (REST POST
  // + validation + lead-done confirmation).
}
